<template>
  <div class="auth-container">
    <div class="auth-card-wrapper">
      <themed-card>
        <div class="auth-form">
          <!-- Logo -->
          <div class="auth-logo">
            <img :src="logoUrl" alt="REoptimizer Logo">
          </div>

          <!-- Cancel Message -->
          <div class="auth-message">
            <div class="auth-message__icon auth-message__icon--error">
              <theme-icon icon="x-circle" type="icons" />
            </div>
            <h1 class="auth-message__title auth-message__title--error">
              Payment Cancelled
            </h1>
            <p class="auth-message__text">
              Your payment was not completed. You can try again or contact support if you need help.
            </p>
          </div>

          <!-- Action Button -->
          <div class="auth-message__actions">
            <themed-button
              variant="default"
              @click="goToLogin"
            >
              Go to login
            </themed-button>
          </div>
        </div>
      </themed-card>

      <!-- Copyright -->
      <p class="auth-copyright">
        &copy;{{ currentYear }} REoptimizer&reg;, LLC. All rights reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignupCancel',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    logoUrl() {
      return '/img/logos/reoptimizer.webp';
    }
  },
  methods: {
    goToLogin() {
      window.location.href = '/login';
    }
  }
}
</script>
